import { render } from "./FlowMenu.vue?vue&type=template&id=c29abfcc&scoped=true&ts=true"
import script from "./FlowMenu.vue?vue&type=script&lang=ts"
export * from "./FlowMenu.vue?vue&type=script&lang=ts"

import "./FlowMenu.vue?vue&type=style&index=0&id=c29abfcc&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c29abfcc"]])

export default __exports__